import { AwsRum, AwsRumConfig } from 'aws-rum-web'

import { CloudwatchRumConfig } from '../common/validations'

let rum: AwsRum | null = null
let isInitializingRum = false

// aws-rum-web cuts stack traces at 1000 characters by default, which truncated about a
// quarter of the errors in the staging pilot.
const errorStackTraceLength = 5000

const normalizeEmail = (email: string) => email.trim().toLowerCase()

const hidePathParameters = (url: string) => {
  const convertedUrl = new URL(url, window.location.origin)
  const pathSegments = convertedUrl.pathname.split('/').map((segment) => {
    if (segment.match(/^\d+$/) || segment.match(/^[0-9a-f-]{36}$/i)) {
      return '***'
    }
    return segment
  })
  convertedUrl.pathname = pathSegments.join('/')
  return convertedUrl.pathname
}

const prepareUrlForTracking = (url: string) => {
  const convertedUrl = new URL(url, window.location.origin)
  convertedUrl.search = ''
  convertedUrl.hash = ''
  return hidePathParameters(convertedUrl.pathname)
}

const recordPageView = (pageId: string) => {
  if (!rum) return
  try {
    rum.recordPageView({ pageId: prepareUrlForTracking(pageId) })
  } catch {
    /* empty */
  }
}

export const initCloudWatchRum = async (
  config: CloudwatchRumConfig,
  userUuid: string,
  userEmail: string | null
) => {
  if (
    !config.enabled ||
    !config.identityPool ||
    !config.applicationId ||
    rum ||
    isInitializingRum
  )
    return

  try {
    isInitializingRum = true

    const rumConfig: AwsRumConfig = {
      sessionSampleRate: config.sampleRate,
      identityPoolId: config.identityPool,
      endpoint: config.endpoint,
      telemetries: [
        ['errors', { stackTraceLength: errorStackTraceLength }],
        'performance',
        'http',
      ],
      allowCookies: true,
      enableXRay: false,
      signing: true,
      releaseId: config.applicationVersion,
      sessionAttributes: {
        site_id: config.siteId,
        tenant_id: config.tenantId,
        user_uuid: userUuid,
        ...(userEmail ? { user_email: normalizeEmail(userEmail) } : {}),
      },
    }

    rum = new AwsRum(
      config.applicationId,
      config.applicationVersion,
      config.region,
      rumConfig
    )

    recordPageView(
      `${window.location.pathname}${window.location.search}${window.location.hash}`
    )
  } catch {
    /* empty */
  } finally {
    isInitializingRum = false
  }
}

export const trackCloudWatchRumPageVisit = (pageId: string) => {
  recordPageView(pageId)
}

export const recordCloudWatchRumError = (error: unknown) => {
  if (!rum) return
  try {
    rum.recordError(error)
  } catch {
    /* empty */
  }
}
